import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabaseClient'
import { X, Zap, Wrench, Star } from 'lucide-react'
import { isDevMode } from '../lib/devMode'

const STORAGE_KEY = 'death_card_last_seen_version'

const typeConfig = {
  new: { icon: Zap, color: '#ff7a18' },
  fix: { icon: Wrench, color: '#4dd6ff' },
  improvement: { icon: Star, color: '#9adb6e' },
}

export default function WhatsNew() {
  const [show, setShow] = useState(false)
  const [version, setVersion] = useState(null)
  const [notes, setNotes] = useState([])

  useEffect(() => { if (isDevMode) return; checkForUpdates() }, [])

  const checkForUpdates = async () => {
    const { data } = await supabase.from('app_versions').select('*').order('released_at', { ascending: false }).limit(1)
    if (!data?.[0]) return
    const lastSeen = localStorage.getItem(STORAGE_KEY)
    if (lastSeen !== data[0].version) { setVersion(data[0].version); setNotes(data[0].notes); setShow(true) }
  }

  const dismiss = () => { localStorage.setItem(STORAGE_KEY, version); setShow(false) }

  if (!show) return null

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.8)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50, padding: 16 }}>
      <div style={{ background: 'linear-gradient(135deg, #2a2e36, #1a1d22)', border: '1px solid #4a5058', boxShadow: '0 4px 20px rgba(0,0,0,.5)', width: '100%', maxWidth: 400, padding: 24, color: '#eaf2fb', fontFamily: "'Saira Condensed', sans-serif" }}>
        <div className="flex justify-between items-start" style={{ marginBottom: 16 }}>
          <div>
            <h2 style={{ fontFamily: "'Orbitron', sans-serif", fontSize: 18, fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', margin: 0 }}>WHAT'S NEW</h2>
            <p style={{ color: '#ff7a18', fontSize: 13, fontWeight: 600, marginTop: 4 }}>Version {version}</p>
          </div>
          <button onClick={dismiss} style={{ background: 'none', border: 'none', color: '#5a6470', cursor: 'pointer' }}><X size={20} /></button>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 20 }}>
          {notes.map((note, i) => {
            const cfg = typeConfig[note.type] || typeConfig.new
            const Icon = cfg.icon
            return (
              <div key={i} className="flex items-start gap-3">
                <Icon size={14} style={{ color: cfg.color, flexShrink: 0, marginTop: 3 }} />
                <p style={{ fontSize: 13 }}>
                  <span style={{ textTransform: 'uppercase', fontSize: 10, fontWeight: 700, marginRight: 8, opacity: 0.5, color: cfg.color }}>{note.type}</span>
                  <span style={{ color: '#eaf2fb' }}>{note.text}</span>
                </p>
              </div>
            )
          })}
        </div>

        <button onClick={dismiss} style={{ width: '100%', fontFamily: "'Orbitron', sans-serif", fontSize: 13, fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', background: 'linear-gradient(135deg, #ff7a18, #d8500a)', color: '#fff5e8', border: 'none', padding: '12px 20px', cursor: 'pointer', boxShadow: '0 0 14px rgba(255,122,24,.5)' }}>
          GOT IT — LET'S PLAY
        </button>
      </div>
    </div>
  )
}
